import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/assistenzaVillaggi',
        name: 'assistenzaVillaggi',
        meta: { sideMenuLabel: "Assistenza villaggi" },
        component: () => import("./views/assistenzaVillaggi.vue")
    },
];

export default routes;